import { Route, Routes, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Layout } from "./ui/components/Layout";
import { ErrorBoundary } from "./ui/components/ErrorBoundary";
import { Cockpit } from "./ui/pages/Cockpit";
import { Landschaften } from "./ui/pages/Landschaften";
import { Import } from "./ui/pages/Import";
import { Personen } from "./ui/pages/Personen";
import { Berechtigungen } from "./ui/pages/Berechtigungen";
import { Rollen } from "./ui/pages/Rollen";
import { Vertrag } from "./ui/pages/Vertrag";
import { Optimierung } from "./ui/pages/Optimierung";
import { Plan } from "./ui/pages/Plan";
import { Gates } from "./ui/pages/Gates";
import { Einstellungen } from "./ui/pages/Einstellungen";
import { Methodik } from "./ui/pages/Methodik";
import { NotFound } from "./ui/pages/NotFound";

function ScrollTop() {
  const { pathname } = useLocation();
  // WICHTIG: Block-Body! Der Kurz-Arrow `() => window.scrollTo(0,0)` würde den
  // Rückgabewert von scrollTo als Effect-Cleanup zurückgeben. In manchen
  // Browsern/Extensions ist der kein `undefined` → React ruft ihn beim nächsten
  // Navigieren als Funktion auf → „l is not a function". Nie den Wert zurückgeben.
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export function App() {
  const { pathname } = useLocation();
  return (
    <Layout>
      <ScrollTop />
      {/* B3: pro Route eine Error Boundary — ein Fehler killt nie die ganze App */}
      <ErrorBoundary key={pathname}>
        <Routes>
          <Route path="/" element={<Cockpit />} />
          <Route path="/landschaften" element={<Landschaften />} />
          <Route path="/import" element={<Import />} />
          <Route path="/personen" element={<Personen />} />
          <Route path="/berechtigungen" element={<Berechtigungen />} />
          <Route path="/rollen" element={<Rollen />} />
          <Route path="/vertrag" element={<Vertrag />} />
          <Route path="/optimierung" element={<Optimierung />} />
          <Route path="/plan" element={<Plan />} />
          <Route path="/gates" element={<Gates />} />
          <Route path="/einstellungen" element={<Einstellungen />} />
          <Route path="/methodik" element={<Methodik />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </ErrorBoundary>
    </Layout>
  );
}
